import { Paper, styled } from '@mui/material';

export const StyledIndividualityItemWrap = styled(Paper)(() => ({
	display: 'flex',
	flexDirection: 'column',
	borderRadius: '16px',
	margin: '0 !important',
	gap: '8px',
	padding: '0px 8px 24px 8px',
}));

export const StyledIndividualityItemImage = styled('img')(() => ({
	width: '100%',
	maxWidth: '100%',
	objectFit: 'cover',
	borderRadius: '10px',
}));

export const StyledIndividualityItemValuesWrap = styled('div')(() => ({
	display: 'flex',
	alignItems: 'center',
	flexWrap: 'wrap',
	gap: '8px',
}));
